const warnedContexts = new Set<string>();

/** Clears one-time warning state. For unit tests only. */
export function resetWarnLegacySetEnabledWarnings(): void {
  warnedContexts.clear();
}

/**
 * Emits a one-time deprecation warning when legacy setEnabled is used.
 * Recommend migrating to the Zustand-based global store from @adsk/alloy-provider.
 *
 * @internal
 */
export function warnLegacySetEnabled(contextName: string): void {
  if (warnedContexts.has(contextName)) {
    return;
  }
  warnedContexts.add(contextName);
  console.warn(
    `[${contextName}] setEnabled is deprecated. Upgrade @adsk/alloy-provider to the latest version to align with the new global store providers.`,
  );
}
